import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RegionService } from 'src/app/shared/services/region.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { KnowledgebaseSettingService } from 'src/app/shared/services/knowledgebase-setting.service';
import { NzMessageService } from 'ng-zorro-antd';

@Component({
  selector: 'app-add-edit-knowledgebase-setting',
  templateUrl: './add-edit-knowledgebase-setting.component.html',
  styleUrls: ['./add-edit-knowledgebase-setting.component.css']
})
export class AddEditKnowledgebaseSettingComponent implements OnInit {
  incLocationsList = [];
  isLocIncLoading: boolean = false;
  searchChange$ = new BehaviorSubject('');
  botForm!: FormGroup;
  isEditMode = false;
  regionList = ['Florida', 'California', 'Canada'];
  availableModels: string[] = ['gpt-4','gpt-3.5','claude-3','grok-1','o3','o3-mini','o1','o1-pro','gpt-o4-mini','gpt-4o-latest','gpt-4.1','gpt-4o','gpt-4o-mini'];
  locInclude: any[] = [];
  locExclude: any[] = [];
  botTypes: string[] = ['Regulations','Fishing Reports','Bait & Tackle','Recipes'];
  isLocExcLoading = false;
  // locationInclusionList =[];
  // locationExclusionList =[];
  excLocationsList: any[] = [];



  compareFn = (o1: any, o2: any): boolean =>
    o1 && o2 ? o1.id === o2.id : o1 === o2;
  http: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private regionService: RegionService,
    private knowledgeBaseService: KnowledgebaseSettingService,
    private messageService: NzMessageService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.isEditMode = !!id;
    this.botForm = this.fb.group({
      name: ['', Validators.required],
      botType: ['Regulations', Validators.required],
      enabled: [true],
      provider: ['openai', Validators.required],
      model: ['', Validators.required],
      scheduleType: ['daily', Validators.required],
      scheduleTime: [null],
      locationInclude: [[],Validators.required],
      locationExclude: [[]],
      promptTemplate: ['',Validators.required],
      fineTuningPrompt: [''],    
      nextRunDate:[]
    });
    this.onProviderChange(this.botForm.value['provider'])




    // If in edit mode, load data
    if (this.isEditMode) {

      this.loadSettingData(id);
      
    }
  }

  onProviderChange(provider: string): void {

    // Load available models based on selected provider
    if (provider === 'openai') {
     this.availableModels = ['gpt-4','gpt-3.5','o3','o3-mini','o1','o1-pro','gpt-o4-mini','gpt-4o-latest','gpt-4.1','gpt-4o','gpt-4o-mini'];
    } else if (provider === 'grok') {
      this.availableModels = ['grok-1', 'grok-1.5'];
    }
    if (this.botForm.get('model')) {
      this.botForm.get('model')!.setValue('');
    }

  }


  onSearchLocInc(value: string): void {

    this.searchChange$.next(value);
    if (!value || value.trim().length < 3) {
      return;
    }
    this.isLocIncLoading = true;
    this.regionService.getAllSystemLocations(value).subscribe(res => {
      this.incLocationsList = res.body;
      this.isLocIncLoading = false;
    });
  }

  onSearchLocExc(value: string): void {
    this.searchChange$.next(value);
    if (!value || value.trim().length < 3) {
      return;
    }
    this.isLocExcLoading = true;
    this.regionService.getAllSystemLocations(value).subscribe(res => {
      this.excLocationsList = res.body;
      this.isLocExcLoading = false;
    });
  }


  submitForm(): void {

if (!this.botForm.valid) {
  this.botForm.markAllAsTouched();

  Object.keys(this.botForm.controls).forEach(key => {
    const control = this.botForm.get(key);
    if (control) {
      control.updateValueAndValidity();
    }
  });

  return;
}
    const data = this.botForm.value;
    // Format schedule time
    if (data.scheduleTime instanceof Date) {
      data.scheduleTime = this.formatTimeToUTC(data.scheduleTime);
    }
    const saveMsgId = this.messageService.loading("Saving...", { nzDuration: 0 }).messageId;

    // Clone and transform data first
    const transformedData = {
      ...data,
      locationExclude: Array.isArray(data.locationExclude)
        ? data.locationExclude.map(loc => loc.id).join(',')
        : '',
      locationInclude: Array.isArray(data.locationInclude)
        ? data.locationInclude.map(loc => loc.id).join(',')
        : ''
    };

    if (this.isEditMode) {
      const editId = this.route.snapshot.paramMap.get('id');

      this.knowledgeBaseService.aiSettingUpdate(editId, transformedData).subscribe({
        next: (res) => {
          setTimeout(() => {
            this.messageService.remove(saveMsgId);
            this.router.navigate(['/setting']);
          }, 1000);
        },
        error: (err) => {
          this.messageService.remove(saveMsgId);
          console.error("API error (update):", err);
        }
      });

    } else {
      this.knowledgeBaseService.addAiSetting(transformedData).subscribe({
        next: (res) => {
          setTimeout(() => {
            this.messageService.remove(saveMsgId);
            this.router.navigate(['/setting']);
          }, 1000);
        },
        error: (err) => {
          this.messageService.remove(saveMsgId);
          console.error("API error (create):", err);
        }
      });
    }


  }

  cancel(): void {
    this.router.navigate(['/setting']);
  }

  // runNow(): void {
  //   const currentValues = this.botForm.value;
  //   console.log('Run now clicked for bot:', currentValues.name);
  //   // Trigger backend logic here
  // }


  private formatTimeToUTC(date: Date): string {
    const hh = String(date.getUTCHours()).padStart(2, '0');
    const mm = String(date.getUTCMinutes()).padStart(2, '0');
    const ss = String(date.getUTCSeconds()).padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  }

  private timeStringToDate(timeString?: string): Date | null {
    if (!timeString) {
      return null;
    }
  
    const [hours, minutes, seconds] = timeString.split(':').map(Number);

    // Create a UTC date for today with given time
    const now = new Date();
    const utcDate = new Date(Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      hours,
      minutes,
      seconds || 0,
      0
    ));
    return new Date(utcDate); // Now treated as local time in browser
  }

  private loadSettingData(id: string | null): void {
    if (!id) return;

    this.knowledgeBaseService.getAiSettingById(id).subscribe({
      next: (res) => {
        if (res['locationExclusionList']) {
          this.excLocationsList = this.excLocationsList.concat(res['locationExclusionList']);
        }

        if (res['locationInclusionList']) {
          this.incLocationsList = this.incLocationsList.concat(res['locationInclusionList']);
        }

        
        this.botForm.patchValue({
          ...res,          
           scheduleTime: this.timeStringToDate(res['scheduleTime']),
          locationExclude: this.excLocationsList.filter(element => res['locationExclusionList'].some(x => x.id === element.id)),
          locationInclude: this.incLocationsList.filter(element => res['locationInclusionList'].some(x => x.id === element.id))
        }); // This fills the form with matching fields
      },
      error: (error) => console.log('Error', error)
    });
  }


}